<template>
  <div>
    <popoverText
      :text="scope.row[tableData.bind]"
      :subText="scope.row[tableData.bind]"
    >
      <ig-icon
        :name="'copy'"
        class="copy-icon"
        v-clipboard="scope.row[tableData.bindCopy]"
        v-clipboard:success="clipboardSuccess"
        v-clipboard:error="onError"
      ></ig-icon>
    </popoverText>
  </div>
</template>

<script>
import popoverText from "./popoverText";
export default {
  name: "copy-text",
  components: {
    popoverText
  },
  props: {
    tableData: Object,
    scope: Object
  },
  methods: {
    clipboardSuccess() {
      this.$message({
        message: "复制到剪贴板成功",
        type: "success",
        duration: 1500
      });
    },
    clickBtn() {
      this.tableData.clickFn(this.scope.row);
    },
    onError() {
      this.$message({
        message: "复制到剪切板失败"
      });
    }
  }
};
</script>

<style scoped lang="scss">
.copy-icon {
  margin-left: 10px;
  margin-right: 20px;
  cursor: pointer;
}
</style>
